package com.downdogapp

enum class Direction {
  LEFT,
  RIGHT,
  TOP,
  BOTTOM;
}
